/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * By default, our Swiper integration currently includes the following modules:
 * If you want to use any other modules, you have to install them first.
 *
 * @link [Swiper React Components](https://swiperjs.com/react#usage)
 */
import {
  Autoplay, EffectFade, FreeMode, Mousewheel, Navigation, Pagination, Scrollbar,
  Thumbs,
} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/free-mode';
import 'swiper/css/mousewheel';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/thumbs';

export const swiperModules = [Autoplay, EffectFade, FreeMode, Mousewheel, Navigation, Pagination, Scrollbar, Thumbs];
